<template>
  <div>
    <!--弹出框-->
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" style="height: 100%">
      <el-dialog title="防汛预案" :visible.sync="dialogVisible" :modal="false" v-dialogDrag :before-close="handleClose"
        :close-on-click-modal="false" :show-close="true" :close-on-press-escape="false">
        <p>基本信息：</p>
        <el-row>
          <el-col :span="12">
            <addressTree @obj="objdata" @close="treeClose" :currentdata="currentData"></addressTree>
          </el-col>
          <el-col :span="12">
            <el-form-item type="type" label="淤地坝编码" prop="ydbCode">
              <el-input type="type" placeholder="淤地坝编码" class="from-el-input" v-model.trim="ruleForm.ydbCode" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item type="type" label="预案名称" prop="yamc">
              <el-input type="type" placeholder="防汛预案名称" class="from-el-input" v-model.trim="ruleForm.yamc"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item type="type" label="编制单位" prop="bzdw">
              <el-input type="type" placeholder="编制单位" class="from-el-input" v-model.trim="ruleForm.bzdw"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item type="type" label="版本号" prop="bbh">
              <el-input type="type" placeholder="版本号" class="from-el-input" v-model.trim="ruleForm.bbh"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item type="type" label="编制日期" prop="bzrq">
              <el-date-picker v-model.trim="ruleForm.bzrq" align="right" type="date"
                value-format="yyyy-MM-dd" class="from-el-input-item" placeholder="编制日期"> </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item type="type" label="状态" prop="status">
              <el-select v-model.trim="ruleForm.status" class="from-el-input" placeholder="状态">
                <el-option v-for="(item,i) in yaList" :key="i" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item type="type" label="简要说明" prop="jysm">
              <el-input type="textarea" class="from-el-input-text" maxlength="200" show-word-limit :rows="4"
                placeholder="简要说明" v-model.trim="ruleForm.jysm" :disabled="false"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <p>详细信息：</p>
        <el-row>
          <el-col :span="12">
            <el-form-item type="type" label="事件分级" prop="sjfj">
              <el-select v-model.trim="ruleForm.sjfj" class="from-el-input" placeholder="事件分级">
                <el-option v-for="(item,i) in sjfjList" :key="i" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item type="type" label="雨情" prop="yq">
              <el-input type="type" placeholder="雨情" class="from-el-input" v-model.trim="ruleForm.yq"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item type="type" label="水情" prop="sq">
              <el-input type="type" placeholder="水情" class="from-el-input" v-model.trim="ruleForm.sq"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item type="type" label="工情" prop="gq">
              <el-input type="type" placeholder="工情" class="from-el-input" v-model.trim="ruleForm.gq"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item type="type" label="应急响应" prop="yjxycs">
              <el-input type="type" placeholder="应急响应措施" class="from-el-input" v-model.trim="ruleForm.yjxycs"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item type="type" label="工程抢险" prop="gcqxcs">
              <el-input type="type" placeholder="工程抢险措施" class="from-el-input" v-model.trim="ruleForm.gcqxcs"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item type="type" label="人员转移" prop="ryzycs">
              <el-input type="type" placeholder="人员转移措施" class="from-el-input" v-model.trim="ruleForm.ryzycs"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="col-class" v-if="states=='xz'||states=='bj' || ImgfileListData1.length!=0">
            <div class="titna">
              <span class="">应急响应流程图</span>
            </div>
            <div class="tp" v-if="states=='xz'||states=='bj'">
              <el-upload action :auto-upload="false" list-type="picture-card" :on-preview="imghandl1" :on-change="imgchanges1"
                :on-remove="imghandleRemove1">
              </el-upload>
              <div class='fujian fujians' v-if="ImgfileListData1.length!=0">
                <ul class="fjhxlist">
                  <li v-for="(item,i) in ImgfileListData1" :key="i">
                    <div class="names" style="text-align: left;">{{item.sourceName}}</div>
                    <div class="names cz">
                      <el-button type="primary" icon="el-icon-download" circle @click="DownloadFile(i,item)" class="btnmargin"></el-button>
                      <el-button type="success" icon="el-icon-delete" v-if="states!='ck'" circle @click="deletesfile(i,item,'xfq')"
                        class="btnmargin"></el-button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="tp tps" v-if="states=='ck' && ImgfileListData1.length!=0">
              <ul class="qrtpul">
                <li class v-for="(item,i) in ImgfileListData1" :key="i">
                  <img :src="item.url" alt style="width:20%; cursor: pointer; float: left;" @click="imgzoom(item.url)" />
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
        <el-row style="margin-top: 15px;">
          <el-col :span="24" class="col-class" v-if="states=='xz'||states=='bj' || ImgfileListData2.length!=0">
            <div class="titna">
              <span class="">人员转移路线图</span>
            </div>
            <div class="tp" v-if="states=='xz'||states=='bj'">
              <el-upload action :auto-upload="false" list-type="picture-card" :on-preview="imghandl2" :on-change="imgchanges2"
                :on-remove="imghandleRemove2">
              </el-upload>
              <div class='fujian fujians' v-if="ImgfileListData2.length!=0">
                <ul class="fjhxlist">
                  <li v-for="(item,i) in ImgfileListData2" :key="i">
                    <div class="names" style="text-align: left;">{{item.sourceName}}</div>
                    <div class="names cz">
                      <el-button type="primary" icon="el-icon-download" circle @click="DownloadFile(i,item)" class="btnmargin"></el-button>
                      <el-button type="success" icon="el-icon-delete" v-if="states!='ck'" circle @click="deletesfile(i,item,'xfh')"
                        class="btnmargin"></el-button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="tp tps" v-if="states=='ck' && ImgfileListData2.length!=0">
              <ul class="qrtpul">
                <li class v-for="(item,i) in ImgfileListData2" :key="i">
                  <img :src="item.url" alt style="width:20%; cursor: pointer; float: left;" @click="imgzoom(item.url)" />
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
        <el-row class="rowTop" v-if="states=='xz'||states=='bj'" style="margin-top: 15px;">
          <el-col :span="24">
            <div class="titna">
              <span class="addSpan">附件</span>
            </div>
            <div class='fujian'>
              <el-upload class="upload-demo" drag action="" multiple :on-remove="handleRemove" :on-change='changes'
                :file-list="fileList" :limit="5" :auto-upload='false'>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </el-upload>
              <div class='fujian fujians' v-if="filetabledata.length!=0">
                <ul class="fjhxlist">
                  <li v-for="(item,i) in filetabledata" :key="i">
                    <div class="names" style="text-align: left;">{{item.sourceName}}</div>
                    <div class="names cz">
                      <el-button type="primary" icon="el-icon-view" circle @click="DownloadFile(i,item)" class="btnmargin"></el-button>
                      <el-button type="success" icon="el-icon-delete" v-if="states!='ck'" circle @click="deletesfilesss(i,item)"
                        class="btnmargin"></el-button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row class="rowTop" v-if="states=='ck'&& filetabledata.length !== 0">
          <el-col :span="24">
            <div class="titna">
              <span class="addSpan">附件</span>
            </div>
            <div class='fujian'>
              <ul class="fjhxlist">
                <li v-if="filetabledata.length==0" style='width:100%;height:80px;line-height: 80px;color:#ccc'></li>
                <li v-for="(item,i) in filetabledata" :key="i" v-if="filetabledata.length!=0">
                  <div class="names" style="text-align: left;">{{item.sourceName}}</div>
                  <div class="names cz">
                    <el-button type="primary" icon="el-icon-view" circle @click="DownloadFile(i,item)" class="btnmargin"></el-button>
                    <el-button type="success" icon="el-icon-delete" v-if="states!='ck'" circle @click="deletesfilesss(i,item)"
                      class="btnmargin"></el-button>
                  </div>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-form-item>
            <el-button round @click="empty()" type="warning">取消</el-button>
            <el-button round v-if="states=='xz'" type="primary" @click="deteRmine('ruleForm','xz')">保 存</el-button>
            <el-button round v-if="states=='bj'" type="primary" @click="deteRmine('ruleForm','bj')">保 存</el-button>
          </el-form-item>
        </span>
      </el-dialog>
    </el-form>
    <!--弹出框-->
    <!-- 图片预览 -->
    <el-dialog :visible.sync="imgdialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
  import {
    ydbjbxxQuery,
    yaSave,
    yaUpdate,
    dictioninfo,
    deleteFile
  } from "@/api/api";
  import addressTree from '@/components/mangement/popupaddressTree.vue';
  import axios from 'axios';
  let date = new Date();
  const currentFdate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
  export default {
    props: {
      mystate: Array
    },
    data() {
      return {
        states: "",
        dialogVisible: true,
        urlsss: '/userApi/minio/updateFileMulti/',
        downloadUrl: "/userApi/minio/downloadFile/",
        ruleForm: {
          ydbName: '',
          ydbCode: '',
          yamc: '',
          bzdw: '',
          bbh: '',
          bzrq: '',
          status: '',
          jysm: '',
          sjfj: '',
          yq: '',
          sq: '',
          gq: '',
          yjxycs: '',
          gcqxcs: '',
          ryzycs: '',
        },
        rules: {
          ydbName: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            },
            {
              min: 1,
              max: 50,
              message: '长度在 1 到 50 个字符',
              trigger: 'blur'
            }
          ],
          ydbCode: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            },
            {
              min: 1,
              max: 50,
              message: '长度在 1 到 50 个字符',
              trigger: 'blur'
            }
          ],
          yamc: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            },
            {
              min: 1,
              max: 50,
              message: '长度在 1 到 50 个字符',
              trigger: 'blur'
            }
          ],
          bzdw: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            },
            {
              min: 1,
              max: 50,
              message: '长度在 1 到 50 个字符',
              trigger: 'blur'
            }
          ],
          bbh: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            },
            {
              min: 1,
              max: 50,
              message: '长度在 1 到 50 个字符',
              trigger: 'blur'
            }
          ],
          bzrq: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            },
            {
              min: 1,
              max: 50,
              message: '长度在 1 到 50 个字符',
              trigger: 'blur'
            }
          ],
          status: [{
            required: true,
            message: "请输入必填项",
            trigger: "change"
          }, ],
          jysm: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            },
            {
              min: 1,
              max: 50,
              message: '长度在 1 到 50 个字符',
              trigger: 'blur'
            }
          ],
          sjfj: [{
            required: true,
            message: '请输入必填项',
            trigger: 'change'
          }],
          yq: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            },
            {
              min: 1,
              max: 50,
              message: '长度在 1 到 50 个字符',
              trigger: 'blur'
            }
          ],
          sq: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            },
            {
              min: 1,
              max: 50,
              message: '长度在 1 到 50 个字符',
              trigger: 'blur'
            }
          ],
          gq: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            },
            {
              min: 1,
              max: 50,
              message: '长度在 1 到 50 个字符',
              trigger: 'blur'
            }
          ],
          yjxycs: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            },
            {
              min: 1,
              max: 50,
              message: '长度在 1 到 50 个字符',
              trigger: 'blur'
            }
          ],
          gcqxcs: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            },
            {
              min: 1,
              max: 50,
              message: '长度在 1 到 50 个字符',
              trigger: 'blur'
            }
          ],
          ryzycs: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            },
            {
              min: 1,
              max: 50,
              message: '长度在 1 到 50 个字符',
              trigger: 'blur'
            }
          ]
        },
        row: null,
        yaList: [],
        sjfjList: [],
        currentData: '',

        fileList: [], // 附件
        filetabledata: [], // 回显附件
        fileUrl: '',

        fileList1: [], // 修复前图片提交
        ImgfileListData1: [], // 修复前图片回显
        fileUrl1: '',
        fileList2: [], // 修复后图片提交
        ImgfileListData2: [], // 修复后图片回显
        fileUrl2: '',
        dialogImageUrl: '',
        imgdialogVisible: false
      };
    },
    created() {
      //初始化数据
    },
    components: {
      addressTree
    },
    methods: {
      //获取防汛预案状态数字字典
      getyaztinfo() {
        let params = {
          type: 'fxya',
          code: 'state'
        };
        dictioninfo(params).then((res) => {
          this.yaList = res.data;
        })
      },
      //获取防汛预案事件分级状态数字字典
      getsjfjinfo() {
        let params = {
          type: 'fxya',
          code: 'level'
        };
        dictioninfo(params).then((res) => {
          this.sjfjList = res.data;
        })
      },
      list(params) {
        let _this = this;
        ydbjbxxQuery(params).then((res) => {
          if (res.data.length !== 1) {
            _this.$notify({
              title: "提示",
              message: "请选择淤地坝",
              type: "warning"
            });
          } else {
            _this.ruleForm.ydbCode = res.data[0].ydbCode;
            _this.ruleForm.ydbName = res.data[0].ydbName;
          }
        })
      },
      treeClose() {
        this.ruleForm.ydbCode = '';
        // let params = {};
        // this.list(params);
      },
      objdata(data) {
        let params = {
          ydbCode: data.ydbCode
        };
        this.list(params);
      },
      deletesfile(index, row, type) { // 删除文件
        let params = {id:row.id, fileName:row.fileName};
        deleteFile(params).then((res) => {
        	if(res.code == 200) {
        		this.$notify({
        			title: '',
        			message: res.message,
        			type: 'success'
        		});
            if(type === 'xfq') this.ImgfileListData1.splice(index, 1);
            if(type === 'xfh') this.ImgfileListData2.splice(index, 1);
            if (type === 'fujian') {
              this.filetabledata.splice(index, 1);
            }
        	}
        })
      },
      deletesfilesss(index, row) { // 删除文件
        let params = {id:row.id, fileName:row.fileName};
        deleteFile(params).then((res) => {
        	if(res.code == 200) {
        		this.$notify({
        			title: '',
        			message: res.message,
        			type: 'success'
        		});
            this.filetabledata.splice(index, 1);
        	}
        })
      },
      handleRemove(file, fileList) { // 删除文件
        for (let i = 0; i < this.fileList.length; i++) {
          if (file.name == this.fileList[i].name) {
            this.fileList.splice(this.fileList[i], 1)
          }
        }
      },
      changes(file, fileList) {
        let num = 1024.00
        if (Number((file.size / Math.pow(num, 2)).toFixed(2)) > 10) {
          fileList.splice(fileList.length - 1, 1)
          this.$message.error('选择文件大于10M，请重新选择！')
        } else {
          this.fileList.push(file.raw)
        }
      },

      deteRmine(formName, type) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let config = {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }; // 添加请求头
            //应急响应流程图Url
            if (this.fileList1.length != 0) {
              let formData1 = new FormData();
              this.fileList1.forEach((el, index) => {
                formData1.append('file', el); // 'file' 可变 相当于 input 表单的name 属性
              });
              axios.post(this.urlsss, formData1, config).then(res => {
                if(res.data.code === 200) {
                  this.fileUrl1 = res.data.data;
                }
              }).catch(err => {});
            }

            //人员转移路线图Url
            if (this.fileList2.length != 0) {
              let formData2 = new FormData();
              this.fileList2.forEach((el, index) => {
                formData2.append('file', el); // 'file' 可变 相当于 input 表单的name 属性
              });
              axios.post(this.urlsss, formData2, config).then(res => {
                if(res.data.code === 200) {
                  this.fileUrl2 = res.data.data;
                }
              }).catch(err => {});
            }

            //附件Url
            if (this.fileList.length != 0) {
              let formData = new FormData();
              this.fileList.forEach((el, index) => {
                formData.append('file', el); // 'file' 可变 相当于 input 表单的name 属性
              });
              axios.post(this.urlsss, formData, config).then(res => {
                if(res.data.code === 200) {
                  this.fileUrl = res.data.data;
                }
              }).catch(err => {});
            }

            let _this = this;
            setTimeout(function() {
              if (type == 'xz') {
                let params = {
                  ydbName: _this.ruleForm.ydbName, //淤地坝名称
                  ydbCode: _this.ruleForm.ydbCode, //淤地坝编号
                  ydbFhyaMc: _this.ruleForm.yamc, //预案名称
                  ydbBzdw: _this.ruleForm.bzdw, //编制单位
                  ydbBbh: _this.ruleForm.bbh, //版本号
                  ydbBzrq: _this.ruleForm.bzrq, //编制日期
                  status: _this.ruleForm.status, //状态
                  ydbJianYao: _this.ruleForm.jysm, //简要说明
                  ydbSjfj: _this.ruleForm.sjfj, //事件分级
                  ydbYuQing: _this.ruleForm.yq, //雨情
                  ydbShuiQing: _this.ruleForm.sq, //水情
                  ydbGongQing: _this.ruleForm.gq, //工情
                  ydbYjxycs: _this.ruleForm.yjxycs, //应急响应措施
                  ydbGcqx: _this.ruleForm.gcqxcs, //工程抢险措施
                  ydbYjxylc: _this.ruleForm.ryzycs, //人员转移措施（应急响应流程）
                  ydbYjxylct: _this.fileUrl1, //应急响应流程图
                  ydbRyzylxt: _this.fileUrl2, //人员转移路线图
                  ydbFuJian: _this.fileUrl, //附件
                };
                yaSave(params).then((res) => {
                  if (res.code === 200) {
                    _this.$notify({
                      title: "提示",
                      message: "提交成功",
                      type: "success"
                    });
                    _this.dialogVisible = false;
                    _this.$emit("adddata", {
                      dialogVisible: _this.dialogVisible
                    });
                  } else {
                    _this.$notify({
                      title: "提示",
                      message: res.message,
                      type: "warning"
                    });
                  }
                })
              } else {
                let zhuangtai, sjfj;
                if (_this.ruleForm.status === '生效') {
                  zhuangtai = 0;
                } else {
                  zhuangtai = 1;
                }
                if (_this.ruleForm.sjfj === '1级') {
                  sjfj = 0;
                } else if (_this.ruleForm.sjfj === '2级') {
                  sjfj = 1;
                } else if (_this.ruleForm.sjfj === '3级') {
                  sjfj = 2;
                } else {
                  sjfj = 3;
                }
                let params = {
                  ydbName: _this.ruleForm.ydbName, //淤地坝名称
                  ydbCode: _this.ruleForm.ydbCode, //淤地坝编号
                  ydbFhyaMc: _this.ruleForm.yamc, //预案名称
                  ydbBzdw: _this.ruleForm.bzdw, //编制单位
                  ydbBbh: _this.ruleForm.bbh, //版本号
                  ydbBzrq: _this.ruleForm.bzrq, //编制日期
                  status: zhuangtai, //状态
                  ydbJianYao: _this.ruleForm.jysm, //简要说明
                  ydbSjfj: sjfj, //事件分级
                  ydbYuQing: _this.ruleForm.yq, //雨情
                  ydbShuiQing: _this.ruleForm.sq, //水情
                  ydbGongQing: _this.ruleForm.gq, //工情
                  ydbYjxycs: _this.ruleForm.yjxycs, //应急响应措施
                  ydbGcqx: _this.ruleForm.gcqxcs, //工程抢险措施
                  ydbYjxylc: _this.ruleForm.ryzycs, //人员转移措施（应急响应流程）
                  ydbYjxylct: _this.fileUrl1, //应急响应流程图
                  ydbRyzylxt: _this.fileUrl2, //人员转移路线图
                  ydbFuJian: _this.fileUrl, //附件
                  id: _this.row.id
                };
                if (params.ydbYjxylct === '') {
                  params.ydbYjxylct = null;
                }
                if (params.ydbRyzylxt === '') {
                  params.ydbRyzylxt = null;
                }
                if (params.ydbFuJian === '') {
                  params.ydbFuJian = null;
                }
                yaUpdate(params).then((res) => {
                  if (res.code === 200) {
                    _this.$notify({
                      title: "提示",
                      message: "提交成功",
                      type: "success"
                    });
                    _this.dialogVisible = false;
                    _this.$emit("bjadddata", {
                      dialogVisible: _this.dialogVisible
                    });
                  } else {
                    _this.$notify({
                      title: "提示",
                      message: res.message,
                      type: "warning"
                    });
                  }
                })
              }
            }, 500)
          }
        });
      },
      empty() {
        this.dialogVisible = false;
        this.$emit("getcancel", {
          dialogVisible: this.dialogVisible
        });
      },
      optionsChange() {

      },
      handleNodeClick(data, e) {

        this.sjcdid = data.id;
        this.ruleForm.sjcd = data.menuName;

      },

      handleClose() {
        this.dialogVisible = false;
        this.$emit("getcancel", {
          dialogVisible: this.dialogVisible
        });
      },

      DownloadFile(index, row) {
        // 下载文件
        window.open(this.downloadUrl + row.fileName);
      },
      deletesfile(index, row, type) {
        // 删除文件
        let params = {
          id: row.id,
          fileName: row.fileName
        };
        deleteFile(params).then((res) => {
          if (res.code == 200) {
            this.$notify({
              title: '',
              message: res.message,
              type: 'success'
            });
            if (type === 'xfq') this.ImgfileListData1.splice(index, 1)
            if (type === 'xfh') this.ImgfileListData2.splice(index, 1)
          }
        })
      },

      imgzoom(url) {
        window.open(url);
      },

      imghandl1(file) {
        this.dialogImageUrl = file.url;
        this.imgdialogVisible = true;
      },

      imghandleRemove1(file, fileList) {
        // 删除文件
        for (let i = 0; i < this.fileList1.length; i++) {
          if (file.name == this.fileList1[i].name) {
            this.fileList1.splice(this.fileList1[i], 1);
          }
        }
      },

      imgchanges1(file, fileList) {
        let num = 1024.0
        if (Number((file.size / Math.pow(num, 2)).toFixed(2)) > 10) {
          fileList.splice(fileList.length - 1, 1)
          this.$message.error('选择文件大于10M，请重新选择！')
        } else {
          this.fileList1.push(file.raw)
        }
      },

      imghandl2(file) {
        this.dialogImageUrl = file.url;
        this.imgdialogVisible = true;
      },

      imghandleRemove2(file, fileList) {
        // 删除文件
        for (let i = 0; i < this.fileList2.length; i++) {
          if (file.name == this.fileList2[i].name) {
            this.fileList2.splice(this.fileList2[i], 1);
          }
        }
      },

      imgchanges2(file, fileList) {
        let num = 1024.0
        if (Number((file.size / Math.pow(num, 2)).toFixed(2)) > 10) {
          fileList.splice(fileList.length - 1, 1)
          this.$message.error('选择文件大于10M，请重新选择！')
        } else {
          this.fileList2.push(file.raw)
        }
      },
    },
    mounted() {
      this.getsjfjinfo();
      this.getyaztinfo();

      this.states = this.mystate[0];
      this.row = this.mystate[1];

      if (this.states == 'bj') {
        this.currentData = this.mystate[1].ydbName; //淤地坝名称

        this.ruleForm.ydbName = this.mystate[1].ydbName; //淤地坝名称
        this.ruleForm.ydbCode = this.mystate[1].ydbCode; //淤地坝编号
        this.ruleForm.yamc = this.mystate[1].ydbFhyaMc; //预案名称
        this.ruleForm.bzdw = this.mystate[1].ydbBzdw; //编制单位
        this.ruleForm.bbh = this.mystate[1].ydbBbh; //版本号
        this.ruleForm.bzrq = this.mystate[1].ydbBzrq; //编制日期
        this.ruleForm.jysm = this.mystate[1].ydbJianYao; //简要说明
        this.ruleForm.yq = this.mystate[1].ydbYuQing; //雨情
        this.ruleForm.sq = this.mystate[1].ydbShuiQing; //水情
        this.ruleForm.gq = this.mystate[1].ydbGongQing; //工情
        this.ruleForm.yjxycs = this.mystate[1].ydbYjxycs; //应急响应措施
        this.ruleForm.gcqxcs = this.mystate[1].ydbGcqx; //工程抢险措施
        this.ruleForm.ryzycs = this.mystate[1].ydbYjxylc; //人员转移措施（应急响应流程）

        this.filetabledata = this.mystate[1].ydbFuJian;
        this.ImgfileListData1 = this.mystate[1].ydbYjxylct;
        this.ImgfileListData2 = this.mystate[1].ydbRyzylxt;

        if (this.mystate[1].status === 0) {
          this.ruleForm.status = '生效'; //状态
        } else {
          this.ruleForm.status = '作废'; //状态
        }

        if (this.mystate[1].ydbSjfj === 0) {
          this.ruleForm.sjfj = '1级';
        } else if (this.mystate[1].ydbSjfj === 1) {
          this.ruleForm.sjfj = '2级';
        } else if (this.mystate[1].ydbSjfj === 2) {
          this.ruleForm.sjfj = '3级';
        } else {
          this.ruleForm.sjfj = '4级';
        }
      }
    }
  };
</script>

<style scoped="scoped">
  >>>.el-dialog {
    width: 1000px;
  }

  >>>.el-dialog__body {
    height: 450px;
    overflow: auto;
  }

  .treebox {
    width: 100%;
    margin: 0;
  }

  .trees {
    width: 98%;
    float: left;
    max-height: 300px;
    height: 60px;
    line-height: 30px;
    padding-left: 2%;
    margin-top: 5px;
  }

  .fujian {
    width: calc(100% - 112px);
    width: -webkit-calc(100% - 112px);
    width: -moz-calc(100% - 112px);
    float: right;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 10px;
    overflow: auto;
  }

  .tp {
    width: calc(100% - 132px);
    float: right;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 10px;
  }

  .addSpan {
    line-height: 30px;
    margin-right: 10px;
  }
</style>
